import { breakpoints } from "@brightagency/headstart-common";
import React from "react";
import styled from "styled-components";
import { colors } from "../../../../utils/colors";


interface Props {
    copy: any;
    logo: any;
    classname:string;
    // logo: WPImage;
}

const Wrapper = styled.div`
    margin: 80px 0 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
    gap: 24px;

    ${breakpoints.large} {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        margin: 0;
    }
`;

const Copy = styled.div`
    color: ${colors.white};
    font-size: 13px;
    text-align: left;

    ${breakpoints.large} {
        font-size: 17px;
        text-align: left;
        margin-bottom: 0;
        width: 280px;
    }
`;

const LogoWrapper = styled.div`
    height: auto;
    width: 100%;
    max-width: 75px;

    img {
        width: 100%;
    }

    ${breakpoints.medium} {
        max-width: 135px;
    }
`;

export const RegionInfo: React.FC<Props> = props => {
    return (
        <Wrapper className={props.classname}>
            <Copy>{props.copy}</Copy>
            <LogoWrapper>
                <img src={props.logo} alt="" />
                {/* <img src={props.logo.url} alt="" /> */}
            </LogoWrapper>
        </Wrapper>
    );
};
